import React from 'react'
import ObjectField from 'App/components/fields/ObjectField'
import Fields from 'orionjs-react-autoform/lib/Fields'
import AutoForm from 'App/components/AutoForm'
import useQuery from 'apollo-hooks/lib/useApolloQuery'
import gql from 'graphql-tag'
import {Field} from 'simple-react-form'

export default function ConditionField({countryCode, option}) {
  const {country} = useQuery({
    query: gql`
      query getCountryConfiguration($countryCode: ID, $option: String) {
        country(countryCode: $countryCode) {
          name
          configuration {
            _id
            schemaToDistanceBonusOption(option: $option)
          }
        }
      }
    `,
    variables: {countryCode, option}
  })

  if (!country || !country.configuration) return null
  const {configuration} = country
  if (!configuration.schemaToDistanceBonusOption) return null

  return (
    <Field fieldName="values" type={ObjectField}>
      <Fields
        getFieldComponent={AutoForm.getFieldComponent}
        params={configuration.schemaToDistanceBonusOption}
      />
    </Field>
  )
}
